export default {
    back: 'Back to objectives',
    title: 'Employees without an objective',
    subtitle: 'Employees who have no published objective for the selected period.',
    cycleLabel: 'Objective period',
    searchPlaceholder: 'Search for an employee',
    incompleteRange: 'Pick both dates of the range to see who has no objective for it.',
    summary_one: '{{count}} employee has no published objective for {{cycle}} ({{range}}).',
    summary_other: '{{count}} employees have no published objective for {{cycle}} ({{range}}).',
    // No window to quote under "all periods": the count then covers every objective there is.
    summaryAllPeriods_one: '{{count}} employee has no published objective in any period.',
    summaryAllPeriods_other: '{{count}} employees have no published objective in any period.',
    draftsDoNotCount:
        'A draft objective does not count: the employee stays on this list until it is published.',
    empty: {
        title: 'Everyone has an objective',
        description: 'Every active employee has at least one objective for this period.',
        noSearchResults: 'No employee matches your search.',
        noFilterResults: 'No employee matches the selected filters.',
    },
    noCycle: {
        message:
            'No objective period is set up. Create a period to track employees without an objective.',
        action: 'Create a period',
    },
    noManager: 'No {{managerLabel}}',
    addObjective: 'Add an objective',
    addObjectiveFor: 'Add an objective for {{name}}',
    entryLink: 'View employees without objectives',
    errors: {
        loading: 'Error loading the employees',
    },
};
